import { StyleSheet } from "react-native";
export default StyleSheet.create({
  wrapper: {
    position: "absolute"
  },
  shadowMenuContainer: {
    opacity: 0,
    paddingVertical: 8,
    elevation: 8
  },
  menuContainerStyles: {}
});